import React from 'react';
import burgerLogo from '../../assets/images/ABC-zainab16.png';
import classes from './BookCard.css';

function bookcard(props) {
var bcolor = props.bcolor;
// alert("bookname:"+JSON.stringify(props.bookname));
return (
    // <div className={classes.book}  style={{ color:"black", width:'96%', flex:"1", alignItems:"space-between", alignSelf: "flex-top", alignContent:"left", justifyContent:"space-between", flexDirection: "row"}}>
    <div style={{width: "fit-content"}}>
    <div className={classes.book} style={{ marginLeft:'30px', background:bcolor, backgroundImage: "linear-gradient(to right,black, 48px, #d3d7ee, 50px, transparent 50px)",    marginTop:'30px',   position:'relative', display:'inline-block'}}>
            <div style={{width:'100%'}}>
                <div style={{fontSize:'1.5em', color:'black', fontWeight:'bold',paddingLeft:'50px',paddingRight:'10px'}}><br></br><br></br>{props.bookname}</div> 
                <div style={{fontSize:'1.0em', fontWeight:'bold',paddingLeft:'50px',color:'#333',paddingRight:'10px'}}>{props.author}</div>
            </div>
    </div>
    </div>
);
}

export default bookcard;


// WEBPACK FOOTER //
// ./src/components/BookCard/BookCard.js